import React, { Component } from 'react';
import EventTimer from './eventTimer'

export default class SoccerBoard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            gameCode: "1",
            statusList: {
                "1000": "Dangerous Attack",
                "1001": "Attack",
                "1002": "In possession",
                "1004": "Corner",
                "1007": "Goal kick",
                "1008": "Penalty",
                "1009": "Direct free kick",
                "1010": "Simple free kick",
                "1024": "Throw",
                "0008": "Penalty Score",
                "0009": "Penalty Miss",
                "0021": "Penalty To Take",
                "1003": "Goal",
                "1005": "Yellow Card",
                "1006": "Red Card",
                "1011": "Shot on goal",
                "1012": "Shot off goal",
                "1013": "Substitution",
                "1014": "Kick off",
                "1015": "Half time",
                "1016": "Second half",
                "1017": "Full time",
                "1018": "Start Extra Time1",
                "1019": "Extra Time Half Time",
                "1020": "Start Extra Time2",
                "1021": "End Of Extra Time",
                "1022": "Penalty shoot out",
                "1023": "Penalty missed",
                "1025": "Injury",
                "1026": "Injury Time",
                "1237": "Zoned Throw",
                "1233": "Match Info",
                "1234": "Offside",
                "1238": "Substitution",
                "11901": "Corner Top-Right",
                "21901": "Corner Top-Left",
                "11902": "Corner Bottom-Right",
                "21902": "Corner Bottom-Left",
                "11931": "Free Kick Top-Right 1",
                "21931": "Free Kick Top-Left1",
                "11932": "Free Kick Bottom-Right 1",
                "21932": "Freekick Bottom-Left 1",
                "11933": "Free Kick Top-Right 2",
                "21933": "Free Kick Top-Left 2",
                "11934": "Freekick Bottom-Right 2",
                "21934": "Free Kick Bottom-Left 2",
                "11935": "Free Kick Top-Right 3",
                "21935": "Free Kick Top-Left 3",
                "11936": "Free Kick Bottom-Right 3",
                "21936": "Free Kick Bottom-Left 3"
            },
            spStatusList: {
                "X1": "Attacks",
                "Y1": "Dangerous Attacks",
                "Z1": "Possession",
                "T1": "Shots on target",
                "K1": "Shots of target",
                "X2": "Attacks",
                "Y2": "Dangerous Attacks",
                "Z2": "Possession",
                "T2": "Shots on target",
                "K2": "Shots of target",
            },
            score: {},
            tvShow: true,
            tvUrl: ""
        };
    }
    componentDidMount() {
        setInterval(() => { this.setState({}) }, 1000)
    }
    getStatusText(data) {
        if (!!data.st && data.st !== "") {
            let stArr = data.st.split("")
            if (stArr[1] === "1") {
                return data.c1.n + " | " + this.state.spStatusList[data.st]
            } else {
                return data.c2.n + " | " + this.state.spStatusList[data.st]
            }
        } else if (!!data.ls && data.ls.n !== "") {
            let stArr = data.ls.c.split("")
            if (stArr.length === 5 && stArr[0] === "1" && !!data.c1 && !!data.ls) {
                return data.c1.n + " | " + data.ls.n
            } else if (stArr.length === 5 && stArr[0] === "2" && !!data.c1 && !!data.ls) {
                return data.c2.n + " | " + data.ls.n
            } else {
                return data.ls.n
            }
        }
        return ""
    }
    formatDate(date) {
        if (!date) {
            return ""
        }
        date = new Date(date)
        let month = [];
        month[0] = "Jan";
        month[1] = "Feb";
        month[2] = "Mar";
        month[3] = "Apr";
        month[4] = "May";
        month[5] = "Jun";
        month[6] = "Jul";
        month[7] = "Aug";
        month[8] = "Sept";
        month[9] = "Oct";
        month[10] = "Nov";
        month[11] = "Dec";
        let mn = date.getMonth() + 1;
        mn = mn > 9 ? mn : "0" + mn
        let dt = date.getDate();
        dt = dt > 9 ? dt : "0" + dt
        let hr = date.getHours();
        hr = hr > 9 ? hr : "0" + hr
        let min = date.getMinutes();
        min = min > 9 ? min : "0" + min
        let year = date.getFullYear()
        let formatedDate = dt + "/" + mn + "/" + year + " " + hr + ":" + min
        return formatedDate
    }
    getEvtTime(totalSec) {
        if (totalSec < 0) {
            return "0:0"
        }
        let secs = 0
        secs = totalSec % 60 | 0
        let totalMins = totalSec / 60 | 0
        return totalMins + ":" + secs
    }
    render() {
        let now = new Date().getTime()
        let eventTime = !!this.props.game && !!this.props.game.event && !!this.props.game.event["openDate"] ? new Date(this.props.game.event["openDate"]).getTime() : now
        let isOpen = !!this.props.game && !!this.props.game.event && !!this.props.game.event["openDate"] ? new Date(this.props.game.event["openDate"]).getTime() < now : false
        let score = this.props.frontData
        let statusString = this.getStatusText(this.props.frontData)
        let enabled_status = [1, 3, 5, 7, 9]
        let isHalf = !!score.p && !!score.ps && ((score.p.c === 3 && (score.dr.s) <= 2700) || (!!score.ps.H1 && !!score.ps.H2 && score.ps.H1.status === 255 && score.ps.H2.status === 0)) ? true : false
        let last_update = !!score.lastUpdated && !!score.p && enabled_status.indexOf(score.p.c) > -1 && !isHalf ? parseInt((now - score.lastUpdated.getTime()) / 1000) : 0
        let matchTime = !!score.dr && score.dr.s ? this.getEvtTime(score.dr.s + last_update) : "0:0"
        return (
            <div className=" live-match">
                <div className={score !== null && !!score.i ? "sub_path center-box crname" : "sub_path center-box crname mb-2"}>
                    <p>
                        {!!this.props.game && !!this.props.game.event && !!this.props.game.competition && <><span>{!!this.props.game && !!this.props.game.event["name"] ? this.props.game.event["name"] : null} - {!!this.props.game && !!this.props.game.competition["name"] ? this.props.game.competition["name"] : null}</span> <span className="f-right">{this.formatDate(this.props.game.event["openDate"])}</span></>}
                    </p>
                </div>
                <div className="livetv mt-1">
                    {!!this.props.tvUrl && this.props.tvUrl !== "" && <>
                        <div className="sub_path center-box crname">
                            <p>
                                <span>Live TV</span>
                                <div className="custom-control custom-switch float-right" style={{ display: "inline" }} onClick={() => { this.props.onOffTv() }}>
                                    <input type="checkbox" className="custom-control-input" checked={this.props.tvShow} />
                                    <label className="custom-control-label" for="customSwitches"></label>
                                </div>
                            </p>
                        </div>
                        <div className="game-wrap col3 mb-0 pb-0">
                            {this.props.tvShow && <div className="mobiletviframe">
                                {!this.props.isNoBalence ? <iframe title={"iframe"} key={"iframe"} id='fp_embed_player' src={this.props.tvUrl} marginWidth='0' marginHeight='0' frameBorder='0' width='100%' height='100%' scrolling='no' allowFullScreen='allowfullscreen'></iframe> :
                                    <div className='no-balence'>You Don't have enough balance to watch Live TV.</div>
                                }
                            </div>}
                        </div>
                    </>
                    }
                </div>
                {score !== null && !!score.i && <div className="game-wrap col3 mb-0">
                    <div className="middle-in-play">
                        {!isOpen ? <EventTimer duration={(eventTime - now) / 1000} /> :
                            <div className="soccerbgbox">
                                <div className="row">
                                    <div className="col-12 text-center"><span className="scoretime">{isHalf ? "Half Time" : !!score && !!score.p ? score.p.n : ""}<span className="ml-1">{matchTime}</span></span></div>
                                </div>
                                <div className="row">
                                    <div className="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-5 text-center">
                                        <span className="tscoreboxmain"><i className="flaticon-football mr-1 soyellow"></i>{!!score && !!score.c1 ? this.props.runners[0].name : this.props.runners[0].name}</span>
                                    </div>
                                    <div className="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-2 text-center">
                                        <div className="tscorebox">
                                            <sapn className="tscorebox1">{!!score && !!score.ps && !!score.ps.TN && !!score.ps.TN.scores ? score.ps.TN.scores.h : ""}</sapn>
                                            <sapn className="teams-devider">:</sapn>
                                            <sapn className="tscorebox1">{!!score && !!score.ps && !!score.ps.TN && !!score.ps.TN.scores ? score.ps.TN.scores.a : ""}</sapn>
                                        </div>
                                    </div>
                                    <div className="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-5 text-center">
                                        <span className="tscoreboxmain"><i className="flaticon-football mr-1 soyellow"></i>{!!score && !!score.c2 ? this.props.runners[1].name : this.props.runners[1].name}</span>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12 text-center"><span className="scoretimedetails">{statusString}</span></div>
                                </div>
                            </div>
                        }
                    </div>
                </div>
                }
            </div>
        )
    }
}
